import { createContext, useState } from 'react';
import {
    createUpdateFormData,
    createUpdateMultipleFields,
    createResetForm,
    getInitialFormData,
} from '../utils/partnerFormUtils.js';

export const PartnerFormContext = createContext();

export const PartnerFormProvider = ({ children, initialData = {} }) => {
    const [formData, setFormData] = useState(getInitialFormData(initialData));
    const [initialFormData, setInitialFormData] = useState(
        getInitialFormData(initialData),
    );
    const [mode, setMode] = useState();
    const [deletedBillingNoteIDs, setDeletedBillingNoteIDs] = useState([]);

    const updateFormData = createUpdateFormData(setFormData);
    const updateMultipleFields = createUpdateMultipleFields(setFormData);
    const resetForm = createResetForm(setFormData, initialData);

    const value = {
        formData,
        setFormData,
        updateFormData,
        updateMultipleFields,
        resetForm,
        mode,
        setMode,
        initialFormData,
        setInitialFormData,
        deletedBillingNoteIDs,
        setDeletedBillingNoteIDs,
    };

    return (
        <PartnerFormContext.Provider value={value}>
            {children}
        </PartnerFormContext.Provider>
    );
};
